import { useState } from "react";
import { toast } from "sonner";
import { Check, Inbox, Loader2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { ddmmyyyy, inr } from "../../lib/format";

export const ReviewQueue = ({ review, onOpen, onChanged }) => {
  const [busy, setBusy] = useState("");
  if (!review?.length) return null;

  const accept = async (po) => {
    setBusy(po.id);
    try {
      await api.patch(`/pos/${po.id}/status`, { status: "Accepted" });
      toast.success(`${po.po_no} accepted`);
      onChanged();
      window.dispatchEvent(new Event("review:changed"));
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="rise space-y-2 rounded-[14px] border border-[hsl(var(--accent-brand)/.45)] bg-accent-soft p-4" data-testid="review-queue">
      <p className="flex items-center gap-2 font-heading font-bold text-brand">
        <Inbox size={18} /> {review.length} new PO{review.length === 1 ? "" : "s"} from the WhatsApp link to review
      </p>
      <div className="divide-y divide-[hsl(var(--accent-brand)/.2)]">
        {review.map((po) => (
          <div key={po.id} className="flex items-center gap-2 py-2" data-testid={`review-item-${po.po_no}`}>
            <button type="button" className="min-w-0 flex-1 text-left" onClick={() => onOpen(po.id)} data-testid={`review-open-${po.po_no}`}>
              <span className="mono text-sm font-bold">{po.po_no}</span> <span className="mono text-sm">{inr(po.total)}</span>
              {po.price_up > 0 && <span className="chip ml-1 border-destructive/50 text-destructive" data-testid={`review-price-up-${po.po_no}`}>▲ {po.price_up} rate{po.price_up === 1 ? "" : "s"} up</span>}
              <span className="block truncate text-xs text-muted-foreground">{po.vendor.name} · by {po.raised_by || "—"} · {ddmmyyyy(po.po_date)}</span>
            </button>
            <button className="btn btn-accent shrink-0 !min-h-[44px] px-3" disabled={busy === po.id} onClick={() => accept(po)} data-testid={`review-accept-${po.po_no}`}>
              {busy === po.id ? <Loader2 size={16} className="animate-spin" /> : <Check size={16} />} Accept
            </button>
          </div>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">Tap a PO to check items and photos, or cancel it from its status menu.</p>
    </div>
  );
};
